import React from 'react';
import {Link} from 'react-router-dom';
import moment from 'moment'
import { injectIntl } from 'react-intl';
import {messages} from  '../common/Translations';

const CourseListRow = ({course, onClone, onDelete, intl}) => {
    return (
        <tr key={course.id}>
            <td scope="row" className="align-middle">{course.id}</td>
            <td className="align-middle">{course.name}</td>
            <td className="align-middle">{course.location.region}</td>
            <td className="align-middle">{moment.unix(course.startDate).format('DD.MM.YYYY')}</td>
            <td className="align-middle">{moment.unix(course.endDate).format('DD.MM.YYYY')}</td>
            <td className="align-middle">{course.price} {course.price && course.currency ? course.currency.name : ''}</td>
            <td className="list-actions text-right align-middle">
                <div className="btn-group text-right">
                    <Link
                        to={`/kurser/rediger/${course.id}`}
                        title="Rediger"
                        className="btn btn-secondary waves-effect list-action"
                    >
                        <i className="fa fa-pencil"/> {intl.formatMessage(messages.listDropDownButtonEdit)}
                    </Link>
                    <button
                        type="button"
                        className="btn clickable btn-secondary dropdown-toggle dropdown-toggle-split"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                    >
                        <span className="sr-only">{intl.formatMessage(messages.listDropDownButtonOptions)}</span>
                    </button>
                    <div className="dropdown-menu">
                        <button
                            title={intl.formatMessage(messages.listDropDownButtonClone)}
                            type="button"
                            className="dropdown-item clickable"
                            onClick={() => onClone(course.id)}
                        >
                            <i className="fa fa-clone"/> {intl.formatMessage(messages.listDropDownButtonClone)}
                        </button>
                        <Link
                            to={`/kurs/vis/${course.id}`}
                            title={intl.formatMessage(messages.listDropDownButtonView)}
                            className="dropdown-item clickable">
                            <i className="fa fa-eye"/> {intl.formatMessage(messages.listDropDownButtonView)}
                        </Link>
                        <div className="dropdown-divider"/>
                        <button
                            title={intl.formatMessage(messages.listDropDownButtonDelete)}
                            type="button"
                            className="dropdown-item clickable"
                            onClick={() => onDelete(course.id)}
                        >
                            <i className="fa fa-trash-o"/> {intl.formatMessage(messages.listDropDownButtonDelete)}
                        </button>
                    </div>
                </div>
            </td>
        </tr>
    );
};

export default injectIntl(CourseListRow);



// WEBPACK FOOTER //
// ./web/src/components/venues-and-courses/CourseListRow.jsx